.formFieldContainer {
    margin: 0px 10px 20px 0px;
    flex: 1;
}
.formContainerDetails {
    display: flex;
    margin: 0px 0px 20px 0px;
}
.tooltip {
    text-align: left;
}